import { Link } from "react-router-dom";
import PageSeo from "../components/PageSeo";
import Nd1SiteNav from "../nd1/components/Nd1SiteNav";
import Nd1SiteFooter from "../nd1/components/Nd1SiteFooter";
import "../nd1/nd1.css";

export default function NotFoundPage() {
  return (
    <div className="nd1-root">
      <PageSeo
        title="Page not found"
        description="That page isn't on JOBUWIN. Head back home or try finding a job instead."
        noindex
      />
      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>
      <Nd1SiteNav />

      <main id="nd1-main" className="nd1-shell nd1-section nd1-not-found">
        <article className="nd1-card nd1-not-found__card">
          <p className="nd1-auth-card__eyebrow">404</p>
          <h1 className="nd1-not-found__title">We couldn&apos;t find that page</h1>
          <p className="nd1-not-found__lede">
            The link might be broken, or the page may have moved. No worries — here&apos;s how to get
            back on track.
          </p>
          <div className="nd1-not-found__actions">
            <Link to="/" className="nd1-btn nd1-btn--primary">
              Back to home
            </Link>
            <Link to="/job-search" className="nd1-btn nd1-btn--outline">
              Find jobs
            </Link>
          </div>
        </article>
      </main>

      <Nd1SiteFooter />
    </div>
  );
}
